import { Card, CardBody, Col, Container, Form, Row } from "reactstrap";
import { Btn } from "../../../../AbstractElements";
import Breadcrumbs from "../../../../CommonElements/Breadcrumbs";
import CommonCardHeader from "../../../../Utils/CommonComponents/CommonCardHeader";
import CommonFileUpload from "../../../../Utils/CommonComponents/CommonFileUpload";
import { AddPostTitle, BlogTitle, Discard, Post, PostEditTitle } from "../../../../Utils/Constants";
import PostEditForm from "./PostEditForm";

export default function AddPostContainer() {
  return (
    <>
      <Breadcrumbs pageTitle={AddPostTitle} parent={BlogTitle} title={AddPostTitle} />
      <Container fluid>
        <Row>
          <Col sm={12}>
            <Card>
              <CommonCardHeader title={PostEditTitle} />
              <CardBody className="add-post">
                <PostEditForm />
                <Form>
                  <CommonFileUpload />
                </Form>
                <div className="btn-showcase text-end blog-btn">
                  <Btn color="primary">{Post}</Btn>
                  <Btn color="transparent" className="bg-light font-dark">
                    {Discard}
                  </Btn>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}
